import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './FootprintEdi.frontend.types'

@Injectable({ providedIn: 'root' })
export class FootprintEdi_edi_sftp_pull_and_submitService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run($inParams: { integration_id: string, sftp_connection: string, sftp_path: string, sftp_extension?: string }): Promise<{ messages?: any[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.integration_id)) {
      $missingRequiredInParams.push('\'integration_id\'');
    }
    if (isNil($inParams.sftp_connection)) {
      $missingRequiredInParams.push('\'sftp_connection\'');
    }
    if (isNil($inParams.sftp_path)) {
      $missingRequiredInParams.push('\'sftp_path\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

}

